export function CrtBlockProgress({ progress = 0, label }) {
  const blocks = 12
  const pct = Math.max(0, Math.min(100, Number(progress) || 0))
  const filled = Math.max(0, Math.min(blocks, Math.round((pct / 100) * blocks)))
  return (
    <div className="crt-block-progress" aria-label={label || 'Loading'}>
      {label ? <span className="crt-block-label">{label}</span> : null}
      <span className="crt-blocks" aria-hidden="true">
        {Array.from({ length: blocks }, (_, i) => (
          <i key={i} className={i < filled ? 'on' : ''} />
        ))}
      </span>
    </div>
  )
}
